// premium-animations: section progress rail
import React, { useState, useEffect } from 'react';

export const ScrollProgress = () => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const progress = Math.min(scrolled / maxScroll, 1);
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="fixed right-6 top-24 bottom-24 w-0.5 bg-stroke-hairline z-50 hidden lg:block">
      <div 
        className="w-full bg-primary transition-all duration-200 ease-out"
        style={{ height: `${scrollProgress * 100}%` }}
      />
    </div>
  );
};